/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedShippingInfo_shipment$ref = any;
export type PdpSharedDetailShipping_shipment$ref = any;
export type PdpSharedDetailShipping_shipment = {
    readonly " $fragmentRefs": PdpSharedShippingInfo_shipment$ref;
    readonly " $refType": PdpSharedDetailShipping_shipment$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipping_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_shipment",
      "args": null
    }
  ]
};
(node as any).hash = 'e9f3329434df464231cc9695b4dad2f4';
export default node;
